/**Controlador para conectar con el backend */
class Food {

    private static _instance: Food;

    private alimentos = [
        {
            name: 'Yogurt',
            img: 'yogurt_img.svg'
        },
        {
            name: 'Plato de fruta',
            img: 'sandia_img.svg'
        },
        {
            name: 'Chilaquiles',
            img: 'chilaquiles_img.svg'
        },
        {
            name: 'Enchiladas',
            img: 'enchiladas_img.svg'
        },
        {
            name: 'Pan Francés',
            img: 'panfrances_img.svg'
        }
    ];


    private bebidas = [
        {
            name: 'Variedad de Café',
            img: 'cafe_img.svg'
        },
        {
            name: 'Chocolate',
            img: 'chocolate_img.svg'
        },
        {
            name: 'Variedad de Té',
            img: 'te_img.svg'
        },
        {
            name: 'Jugos de Fruta',
            img: 'jugofruta_img.svg'
        }
    ];

    private entradas = [
        {
            name: 'Ensalada Cesar de pollo',
            img: 'ensalada_img.svg'
        },
        {
            name: 'Ensalada Caprese',
            img: 'ensalada2_img.svg'
        },
        {
            name: 'Quesos',
            img: 'quesos_img.svg'
        }
    ];

    private sopas = [
        {
            name: 'Caldo Tlalpeño',
            img: 'caldo_img.svg'
        },
        {
            name: 'Sopa de Tortilla',
            img: 'sopa_img.svg'
        }
    ];

    private pastas = [
        {
            name: 'Fetuccini Alfredo',
            img: 'pasta_img.svg'
        },
        {
            name: 'Spaghetti arrabiata',
            img: 'pasta2_img.svg'
        }
    ];

    private platosFuertes = [
        {
            name: 'Fajitas de Pollo, Res o Vegetales',
            img: 'fajitas_img.svg'
        },
        {
            name: 'Club Sandwich',
            img: 'sandwich_img.svg'
        },
        {
            name: 'Sandwich Pepito',
            img: 'sandwich2.svg'
        }
    ];

    private postres = [
        {
            name: 'Brownie',
            img: 'brownie.svg'
        },
        {
            name: 'Pay Relleno',
            img: 'pay_img.svg'
        },
        {
            name: 'Variedad de Pasteles',
            img: 'pastel_img.svg'
        }
    ];
    public static get Instance() {
        // Obtener instancia unica
        return this._instance || (this._instance = new this());
    }

    public getAlimentos() {
        return this.alimentos;
    }

    public getBebidas() {
        return this.bebidas;
    }

    public getEntradas() {
        return this.entradas;
    }

    public getPastas() {
        return this.pastas;
    }

    public getSopas() {
        return this.sopas;
    }

    public getPF() {
        return this.platosFuertes;
    }

    public getPostres() {
        return this.postres;
    }

}

export const FoodService = Food.Instance;
